import { render, staticRenderFns } from "./BtnAtualizarAporteParceiro.vue?vue&type=template&id=34f8e1e6"
import script from "./BtnAtualizarAporteParceiro.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarAporteParceiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports